const cartDrawer = document.querySelector("#custom-cart-drawer");
const cartIconToggle = document.querySelector("#cart-icon-toggle");
const drawerClose = cartDrawer.querySelectorAll(".drawer__close");
// const cartDrawerItems = cartDrawer.querySelector("#cart-drawer-items");
const cartDrawerBackDrop = cartDrawer.querySelector(".cart-drawer__backDrop");

cartIconToggle.setAttribute('role', 'button');
cartIconToggle.setAttribute('aria-haspopup', 'dialog');

cartIconToggle.addEventListener("click", onOpen);
drawerClose.forEach(ele => ele.addEventListener("click", onClose));
cartDrawerBackDrop.addEventListener("click", onClose);

function onOpen(event) {
  console.log("open");
  event.preventDefault();
   setTimeout(() => {
    cartDrawer.classList.add('animate', 'active');
    removeLineItem();
  });
  document.body.classList.add('overflow-hidden');
}

function onClose(){
  console.log("close");
  cartDrawer.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}

function onChange(event){
  const inputValue = parseInt(event.target.value);
  const index = event.target.dataset.index;
  console.log("changed", index, inputValue);
  onUpdateQty(index, inputValue, document.activeElement.getAttribute('name'));
}

function onUpdateQty(id, qty, activeElement){
  console.log("updated",id, qty);
  const cartDrawerItemSpinner = cartDrawer.querySelector(`#cartDrawerItem-${id} .loading__spinner`);
  if(cartDrawerItemSpinner) cartDrawerItemSpinner.classList.remove('hidden');
  let sections = ['custom-cart-drawer','cart-icon-toggle'];
  const body = JSON.stringify({
    line: id,
    quantity: qty,
    sections: sections,
    sections_url: window.location.pathname
  });
  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
  .then(response =>{
    return response.text();
  })
  .then(state => {
    const parsedState = JSON.parse(state);
    const cartDrawerQuantityElement = document.getElementById(`cartDrawer-Quantity-${id}`);
    const items = document.querySelectorAll('.cart-item');
    const CartDrawerError = document.getElementById(`CartDrawer-Error-${id}`);
    
    if(parsedState.errors){
      cartDrawerQuantityElement.value = cartDrawerQuantityElement.getAttribute('value');
      if (CartDrawerError) CartDrawerError.querySelector('.cart-item__error-text').textContent = parsedState.errors;
      return;
    }
    cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
    sections.forEach(section => {
      let replaseElement = document.querySelector(`#${section}`).querySelector("#cart-drawer-items") || document.querySelector(`#${section}`);
      
      const newSection = new DOMParser().parseFromString(parsedState.sections[section], 'text/html').querySelector(`#${section}`);
      const cartDrawerItems = newSection ? newSection.querySelector("#cart-drawer-items") : null;
      
      if (cartDrawerItems) {
        replaseElement.innerHTML = cartDrawerItems.innerHTML;
        removeLineItem();
      } else {
        replaseElement.innerHTML = newSection ? newSection.innerHTML : '';
      }
    });
  })
  .catch((error) => {
    console.error("Error: ", error);
  })
  .finally(() => {
    if(cartDrawerItemSpinner) cartDrawerItemSpinner.classList.add('hidden');
  });
}

cartDrawer.addEventListener("change", debounce(onChange, 300));
// removeLineItem();

function removeLineItem(){
  cartDrawer.querySelectorAll(".line-item-remove").forEach((ele) => {
    ele.addEventListener("click", async (event) => {
  event.preventDefault();
      console.log("remove");
      let cartItem = event.target.closest('.cart-item');
      let bundleId = cartItem.dataset.bundleId;
      if(!bundleId){
        console.log("product don't have any bundle id!");
        // console.log(cartItem, bundleId);
        onUpdateQty(event.target.dataset.index,0);
      }else{
        if (window.confirm("Do you want to remove all product have same bundle id?")) {
          const cart = await fetch('/cart.js').then(response => response.json());
          const itemsToRemove = cart.items.filter(item => item.properties && item.properties['bundle-id'] == bundleId);
          for (const item of itemsToRemove) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0,
              }),
            });
          }
          refreshCartDrawer();
          console.log("Yes, remove all product have same bundle id");
          // console.log(cartItem, bundleId, cart);
        }else{
          console.log("No");
          // console.log(cartItem, bundleId);
          onUpdateQty(event.target.dataset.index,0);
        }
      }
    })
  })
}
function refreshCartDrawer() {
  fetch(`?sections=custom-cart-drawer,cart-icon-toggle`)
  .then(cartResponse => {
      return cartResponse.json();
  })
  .then(sections => {
    const selectors = ['custom-cart-drawer','cart-icon-toggle'];
    for (const selector of selectors) {
      let replaseElement = document.querySelector(`#${selector}`);
      const newSection = new DOMParser().parseFromString(sections[selector], 'text/html').querySelector(`#${selector}`);
      if (replaseElement && newSection) {
        replaseElement.innerHTML = newSection.innerHTML;
        let drawerItem = replaseElement.querySelector(`#cart-drawer-items`);
        if(drawerItem) drawerItem.classList.contains('is-empty') ? replaseElement.classList.add('is-empty') : replaseElement.classList.remove('is-empty');
      }
    }
    setTimeout(() => {
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      cartDrawer.querySelectorAll(".drawer__close").forEach(ele => ele.addEventListener("click", onClose));
      cartDrawer.querySelector(".cart-drawer__backDrop").addEventListener("click", onClose);
      removeLineItem();
    }, 1000);
  })
  .catch(error => {
      console.error("Fetch error:", error);
  });
}
